import { LOCALSTORAGE_KEYS } from '@constants';
import { ApolloClient, createHttpLink, InMemoryCache, ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { RetryLink } from '@apollo/client/link/retry';
import { v4 } from 'uuid';

function getDeviceId() {
  let id = localStorage.getItem(LOCALSTORAGE_KEYS.DEVICE_ID);

  if (!id) {
    id = v4();
    localStorage.setItem(LOCALSTORAGE_KEYS.DEVICE_ID, id);
  }

  return id;
}

export function createApolloClient(token?: string) {
  const httpLink = createHttpLink({
    uri: `${process.env.REACT_APP_API}/graphql`,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      authorization: token || localStorage.getItem(LOCALSTORAGE_KEYS.TOKEN) || '',
      appplatform: 'web',
      deviceid: getDeviceId(),
      devicename: navigator.userAgent,
    },
  }));

  const retryLink = new RetryLink({
    delay: {
      max: 10 * 1000,
    },
    attempts: {
      max: 10,
    },
  });

  return new ApolloClient({
    link: ApolloLink.from([retryLink, authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
      },
    },
  });
}

export default createApolloClient();
